export const countryCurrencyContent = {
  US: {code: 'USD', symbol: '$'},   // United States Dollar
  CA: {code: 'CAD', symbol: 'C$'},  // Canadian Dollar
  GB: {code: 'GBP', symbol: '£'},   // British Pound Sterling
  EU: {code: 'EUR', symbol: '€'},   // Euro
  IN: {code: 'INR', symbol: '₹'},   // Indian Rupee
  AU: {code: 'AUD', symbol: '$'},  // Australian Dollar
  SG: {code: 'SGD', symbol: 'S$'},  // Singapore Dollar
  JP: {code: 'JPY', symbol: '¥'},   // Japanese Yen
  CN: {code: 'CNY', symbol: '¥'},   // Chinese Yuan
  KR: {code: 'KRW', symbol: '₩'},   // South Korean Won
  BR: {code: 'BRL', symbol: 'R$'},  // Brazilian Real
  ZA: {code: 'ZAR', symbol: 'R'},   // South African Rand
  MX: {code: 'MXN', symbol: '$'},   // Mexican Peso
  RU: {code: 'RUB', symbol: '₽'},   // Russian Ruble
  SA: {code: 'SAR', symbol: '﷼'},   // Saudi Riyal
  AE: {code: 'AED', symbol: 'د.إ'}, // UAE Dirham
  CH: {code: 'CHF', symbol: 'CHF'}, // Swiss Franc
  SE: {code: 'SEK', symbol: 'kr'},  // Swedish Krona
  NO: {code: 'NOK', symbol: 'kr'},  // Norwegian Krone
  DK: {code: 'DKK', symbol: 'kr'},  // Danish Krone
  TH: {code: 'THB', symbol: '฿'},   // Thai Baht
  ID: {code: 'IDR', symbol: 'Rp'},  // Indonesian Rupiah
  HK: {code: 'HKD', symbol: 'HK$'}, // Hong Kong Dollar
  NZ: {code: 'NZD', symbol: 'NZ$'}, // New Zealand Dollar
  MY: {code: 'MYR', symbol: 'RM'},  // Malaysian Ringgit
  PH: {code: 'PHP', symbol: '₱'},   // Philippine Peso
  EG: {code: 'EGP', symbol: 'E£'},  // Egyptian Pound
  PK: {code: 'PKR', symbol: '₨'},   // Pakistani Rupee
  NG: {code: 'NGN', symbol: '₦'},   // Nigerian Naira
  BD: {code: 'BDT', symbol: '৳'},   // Bangladeshi Taka
};
